const components = {
  DsfAuditDesign: dsf.defineAsyncComponent("DsfAuditDesign", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditDesigner.vue"
    )
  ),
  DsfAuditOperatorPanel: dsf.defineAsyncComponent("DsfAuditOperatorPanel", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditOperatorPanel.vue"
    )
  ),
  DsfAuditFunctionPanel: dsf.defineAsyncComponent("DsfAuditFunctionPanel", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditFunctionPanel.vue"
    )
  ),
  DsfAuditEditor: dsf.defineAsyncComponent("DsfAuditEditor", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditEditor.vue"
    )
  ),
  DsfAuditV2FormulaForm: dsf.defineAsyncComponent("DsfAuditV2FormulaForm", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditV2Form.vue"
    )
  ),
  DsfAuditFlowState: dsf.defineAsyncComponent("DsfAuditFlowState", () =>
    dsf
      .requestAsyncComponents([$mixins.formFormulaAuditMixinControl])
      .then(() =>
        import(
          /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditFlowState.vue"
        )
      )
  ),
  DsfAuditInfoPanel: dsf.defineAsyncComponent("DsfAuditInfoPanel", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditInfoPanel.vue"
    )
  ),
  DsfAuditVariablePanel: dsf.defineAsyncComponent("DsfAuditVariablePanel", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditVariablePanel.vue"
    )
  ),
  DsfAuditResultList: dsf.defineAsyncComponent("DsfAuditResultList", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditResultList.vue"
    )
  ),
  DsfAuditBlockText: dsf.defineAsyncComponent("DsfAuditBlockText", () =>
    import(
      /*webpackChunkName:"platform_pc_audit_designer"*/ "./auditBlockText.vue"
    )
  ),
};

const install = dsf.createDsfVueInstall("platform", components);

export { install };
export default install;
